export default function checkEmail(str: string) {
  const regex = new RegExp(/\S+@\S+\.\S+/);
  return regex.test(str);
}
